import React from "react";

const CardFechasVencimiento = ({ mes, vencimiento, id }) => {
  let now = new Date();
  let salida = new Date(vencimiento);
  const vigente = +now <= +salida;
  let fecha = salida.toLocaleString().split(',');
  if (fecha.length === 1) {
    fecha = salida.toLocaleString().split(' ');
  }

  return (
    <tr id={id}>
      <td><b>{mes}</b></td>
      <td>
        <span className={vigente ? 'esen-chip esen-chip--success' : 'esen-chip esen-chip--danger'}>
          <i className={vigente ? 'fa fa-thumbs-up' : 'fa fa-hand-paper-o'} aria-hidden="true"></i>
          {fecha[0]}
        </span>
      </td>
    </tr>
  );
};

export default CardFechasVencimiento;
